import { useMemo, useState } from 'react'
import { trasformaFileInBase64, WizardSincronizzatoConRotta, BaseFeedbackConIcona, calcolaFileNameConEstensione } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import { DATICONDUCENTE_VERBALE_DECURTAZIONE } from 'configuration/datiConducente'
import ConfigManager from 'components/config/ConfigManager'
import TitoloTab from 'components/ui/TitoloTab'
import Testo from 'components/ui/Testo'
import Titoletto from 'components/ui/Titoletto'
import BadgeStatoDatiConducente from 'components/ui/datiConducente/BadgeStatoDatiConducente'
import { useDatiConducenteContext } from 'context/DatiConducenteProvider'
import useSchermoStretto from 'hook/useSchermoStretto'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'
import useStateConSessione from 'utils/useStateConSessione'
import useNavigate from 'utils/useNavigate'
import { MODALITA_INVIO_DATI_CONDUCENTE } from '../utilDatiConducente'
import DecurtazionePuntiSituazione from './DecurtazionePuntiSituazione'
import DecurtazionePuntiInserisciDati from './DecurtazionePuntiInserisciDati'
import DecurtazionePuntiInvioModulo from './DecurtazionePuntiInvioModulo'
import DecurtazionePuntiConsegnaModulo from './DecurtazionePuntiConsegnaModulo'

const CFG = DATICONDUCENTE_VERBALE_DECURTAZIONE

const CHIAVI_TABS = {
  SITUAZIONE: 'situazione',
  INSERISCI_DATI: 'inserisciDati',
  INVIO_MODULO: 'invioModulo',
  CONSEGNA_MODULO: 'consegnaModulo',
}
DecurtazionePunti.CHIAVI_TABS = CHIAVI_TABS

export default function DecurtazionePunti(props) {
  return (
    <ConfigManager elenchiConfig={[ELENCHI.CFG_DATICONDUCENTE_VERBALE_DECURTAZIONE]}>
      {propsConfig => <DecurtazionePuntiInterna {...propsConfig} {...props} />}
    </ConfigManager>
  )
}



function DecurtazionePuntiInterna(props) {
  const {
    val, txt,
    verbale,
    chiaveVerbale,
    propsWizard,
  } = props

  const {
    numero_verbale,
    anagrafica,
    dati_conducente,
    modalita: modalitaInvioAbilitate,
  } = verbale

  const [situazione, setSituazione] = useState(dati_conducente?.tipo || '')
  const [datiInseriti, setDatiInseriti] = useState(dati_conducente?.dichiarazione ?? null)
  const [moduloBin, setModuloBin] = useState(dati_conducente?.bin || '')
  const [modalitaInvio, setModalitaInvio] = useStateConSessione('', `datiConducente_${chiaveVerbale}_modalitaInvio`, ({ rimuoviSe: !chiaveVerbale }))
  const [email, setEmail] = useStateConSessione('', `datiConducente_${chiaveVerbale}_email`, ({ rimuoviSe: !chiaveVerbale }))
  const [fileCaricati, setFileCaricati] = useState(null)

  const [messaggioErrore, setMessaggioErrore] = useState(null)

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  async function completaDecurtazionePunti() {
    if (modalitaInvio !== MODALITA_INVIO_DATI_CONDUCENTE.CARICA_ONLINE) {
      vaiAllaPaginaCompletamento()
      return
    }

    const { modulo, patente, verbale } = fileCaricati
    const { ok, data } = await inviaOperazione(OPERAZIONI.UPLOAD_MODULO_CONDUCENTE, {
      chiave: chiaveVerbale,
      moduloFilename: calcolaFileNameConEstensione('decurtazionePunti', modulo.type),
      moduloB64: (await trasformaFileInBase64(modulo)).base64,
      ...(patente && {
        patenteFilename: calcolaFileNameConEstensione('patente', patente.type),
        patenteB64: (await trasformaFileInBase64(patente)).base64,
      }),
      ...(verbale && {
        verbaleFilename: calcolaFileNameConEstensione('verbale', verbale.type),
        verbaleB64: (await trasformaFileInBase64(verbale)).base64,
      }),
      mail: email
    })
    if (ok) {
      const { esito, messaggio } = data
      if (esito) vaiAllaPaginaCompletamento()
      else setMessaggioErrore(messaggio)
    }
  }

  const { setChiaveVerbaleCompletamento } = useDatiConducenteContext()

  const { navigate } = useNavigate()

  function vaiAllaPaginaCompletamento() {
    setChiaveVerbaleCompletamento(chiaveVerbale)
    navigate(CHIAVI_ROUTES.DATI_CONDUCENTE_VERBALE_COMPLETAMENTO, { modalitaInvio })
  }

  const schermoStretto = useSchermoStretto()

  const tabs = useMemo(() => {
    const condizioneInserisciDati = situazione
    const condizioneInvioModulo = condizioneInserisciDati && moduloBin
    const condizioneConsegnaModulo = condizioneInvioModulo && modalitaInvio
    const condizioneCompletaDecurtazione = condizioneConsegnaModulo && (
      modalitaInvio !== MODALITA_INVIO_DATI_CONDUCENTE.CARICA_ONLINE || Boolean(fileCaricati)
    )
    const isAzienda = Boolean(anagrafica?.societa)
    return [
      {
        chiave: CHIAVI_TABS.SITUAZIONE,
        titolo: <TitoloTab numero={1} titolo={txt(CFG.TABS_SITUAZIONE)} />,
        Contenuto: () => (
          <DecurtazionePuntiSituazione
            val={val} txt={txt}
            situazione={situazione}
            setSituazione={situa => {
              setSituazione(situa)
              setDatiInseriti(null)
              setModuloBin('')
              setModalitaInvio('')
              setEmail('')
              setFileCaricati(null)
            }}
            isAzienda={isAzienda}
          />
        ),
      },
      {
        chiave: CHIAVI_TABS.INSERISCI_DATI,
        titolo: <TitoloTab numero={2} titolo={txt(CFG.TABS_INSERISCI_DATI)} disabled={!condizioneInserisciDati} />,
        Contenuto: () => (
          <DecurtazionePuntiInserisciDati
            val={val} txt={txt}
            chiaveVerbale={chiaveVerbale}
            situazione={situazione}
            datiInseriti={datiInseriti}
            setDatiInseriti={setDatiInseriti}
            setModuloBin={bin => {
              setModuloBin(bin)
              setModalitaInvio('')
              setEmail('')
              setFileCaricati(null)
            }}
            isAzienda={isAzienda}
            anagrafica={anagrafica}
          />
        ),
        validate: { condition: () => condizioneInserisciDati },
      },
      {
        chiave: CHIAVI_TABS.INVIO_MODULO,
        titolo: <TitoloTab numero={3} titolo={txt(CFG.TABS_INVIO_MODULO)} disabled={!condizioneInvioModulo} />,
        Contenuto: () => (
          <DecurtazionePuntiInvioModulo
            val={val} txt={txt}
            chiaveVerbale={chiaveVerbale}
            moduloBin={moduloBin}
            modalitaInvio={modalitaInvio}
            setModalitaInvio={modalita => {
              setModalitaInvio(modalita)
              setEmail('')
              setFileCaricati(null)
            }}
            modalitaInvioAbilitate={modalitaInvioAbilitate}
          />
        ),
        validate: { condition: () => condizioneInvioModulo },
      },
      {
        chiave: CHIAVI_TABS.CONSEGNA_MODULO,
        titolo: <TitoloTab numero={4} titolo={txt(CFG.TABS_CONSEGNA_MODULO)} disabled={!condizioneConsegnaModulo} />,
        Contenuto: () => (
          <DecurtazionePuntiConsegnaModulo
            val={val} txt={txt}
            situazione={situazione}
            modalitaInvio={modalitaInvio}
            email={email}
            setEmail={setEmail}
            emailDichiarante={datiInseriti.dichiarante.email}
            fileCaricati={fileCaricati}
            setFileCaricati={setFileCaricati}
          />
        ),
        validate: { condition: () => condizioneConsegnaModulo },
        propsBottoneAvanti: {
          disabled: !condizioneCompletaDecurtazione,
          ...(inAttesaDelServer && { inAttesa: true, disabled: true })
        },
      },
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chiaveVerbale, situazione, datiInseriti, anagrafica, moduloBin, modalitaInvio, email, modalitaInvioAbilitate, fileCaricati, inAttesaDelServer])

  return (
    <>
      <Titoletto>
        {txt(CFG.TITOLO)} {numero_verbale}
        <BadgeStatoDatiConducente verbale={verbale} sx={{ ml: 4 }} />
      </Titoletto>
      <Testo sx={{ mb: 3 }}>{txt(CFG.SOTTOTITOLO)}</Testo>

      <WizardSincronizzatoConRotta
        nomeParamTab='sottotab'
        smallMode='sm'
        tabs={tabs}
        chiaveRottaBase={CHIAVI_ROUTES.DATI_CONDUCENTE_VERBALE_DECURTAZIONE}
        noPaddingX
        onClickBottoneAvantiUltimaTab={completaDecurtazionePunti}
        {...(schermoStretto && { orientation: 'vertical' })}
        {...propsWizard}
      />

      {ScatolaMessaggi}
      {messaggioErrore && <BaseFeedbackConIcona.Errore messaggio={messaggioErrore} />}
    </>
  )
}